import AuthenticationService from '@/services/auth/AuthenticationService'

const login = JSON.parse(localStorage.getItem('login'))

const initialState = login
  ? { status: { isLoggedIn: true }, login }
  : { status: { isLoggedIn: false }, login: null }

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isLoggedIn: state => state.status.isLoggedIn,
    accessType: state => state.login.accessType
  },
  actions: {
    login ({ commit }, login) {
      return AuthenticationService.login(login).then(
        login => {
          commit('LOGIN_SUCCESS', login)
          return Promise.resolve(login)
        },
        error => {
          commit('LOGIN_FAILURE')
          return Promise.reject(error)
        })
    },
    loginReLink ({ commit }) {
      console.log(this.state)
      return AuthenticationService.loginReLink({ code: this.state.authentication.login.code, link: this.state.authentication.login.link }).then(
        login => {
          commit('LOGIN_SUCCESS', login)
          return Promise.resolve(login)
        },
        error => {
          commit('LOGIN_FAILURE')
          return Promise.reject(error)
        })
    },
    loginLink ({ commit }, linkLogin) {
      return AuthenticationService.loginLink(linkLogin).then(
        login => {
          commit('LOGIN_SUCCESS', login)
          return Promise.resolve(login)
        },
        error => {
          commit('LOGIN_FAILURE')
          return Promise.reject(error)
        })
    },
    logout ({ commit }) {
      AuthenticationService.logout()
      commit('LOGOUT')
    },
    refreshToken ({ commit }, { accessToken, refreshToken }) {
      commit('REFRESH_TOKEN', { accessToken, refreshToken })
    }
  },
  mutations: {
    LOGIN_SUCCESS (state, login) {
      state.status.isLoggedIn = true
      state.login = login
    },
    LOGIN_FAILURE (state) {
      state.status.isLoggedIn = false
      state.login = null
    },
    LOGOUT (state) {
      state.status.isLoggedIn = false
      state.login = null
    },
    REFRESH_TOKEN (state, { accessToken, refreshToken }) {
      state.login = { ...state.login, accessToken: accessToken, refreshToken: refreshToken }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js